import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  // No server function in this app requires an authenticated Supabase session
  // (the lead form posts to /api/public/leads). Registering attachSupabaseAuth
  // here would pull @supabase/auth-js, storage-js and realtime into the public
  // homepage bundle for no benefit. Re-add it if auth-protected serverFns land.
  functionMiddleware: [],
  requestMiddleware: [errorMiddleware],
}));
